import { useEffect, useState } from 'react'
import { useToggleEnvironment } from '@yuno/dashboard-container-mfe'
import { mercadoPago } from '../components/connection-form/constants'
import { ITestKey } from '../interfaces/connection.interfaces'

export type UseTestKeysProps = {
  testKeyValues?: ITestKey[]
  currentMode?: 'edit' | 'create'
  availableFields: any
  resetField: (string) => void
  setValue: (field: string, value: string | boolean |void) => void
  trigger: (string) => void
}

export const useTestKeys = ({
    testKeyValues,
    currentMode,
    availableFields,
    resetField,
    setValue,
    trigger,
  } : UseTestKeysProps ) => {
    const { getModeStatus } = useToggleEnvironment()
    const hasTestKeysAvailable = (currentCountry ?: string, currentPaymentMethod ?: string) => {
      return  getModeStatus() === 'ON' && 
      testKeyValues.length &&
      testKeyValues.some(
        (obj) => (obj.country.toLowerCase() === 'global' || 
        (currentPaymentMethod !== null &&  obj.payment_method === currentPaymentMethod && obj.country === currentCountry) ||
        (currentPaymentMethod === null &&  obj.payment_method === null && obj.country === currentCountry)
      ))  
    }
    const isCreateMode = currentMode === 'create'
    const isTestValue = (currentValue: string) => currentValue === 'input_test_value'
    const [usedTestKey, setUsedTestKey] = useState(false)
    const { enabledPaymentMethodsKeyParam, guestModeKeyParam } = mercadoPago
    
    const handleTestKeyButton = (hasTestValue: boolean) => {
      setValue('params_with_test_values', !hasTestValue)
      setUsedTestKey(!usedTestKey)
      availableFields.map((field: { param_id: string }) => {
        if (field?.param_id !== enabledPaymentMethodsKeyParam && field?.param_id !== guestModeKeyParam) {
          const currentValue = !!usedTestKey ? resetField(field.param_id) : 'input_test_value'
          setValue(field.param_id, currentValue)
          trigger(field.param_id)
        }
      })
    }

    const resetTestKeyProps= () => {
      availableFields?.map((field) => {
        setValue(field.param_id, null)
      })
      setUsedTestKey(false)
    }
  
    return {
        hasTestKeysAvailable: hasTestKeysAvailable,
        isCreateMode: isCreateMode,
        isTestValue: isTestValue,
        handleTestKeyButton: handleTestKeyButton,
        resetTestKeyProps: resetTestKeyProps,
    }
  }
  